// extracted by mini-css-extract-plugin
export default {"button__button":"styles_button__button__bkE4X"};